import {paste, pasteImage} from "./commands.js";
import {parsedUrlType} from "../../links.js";
import {pasteListener} from "./shift.js";
import {clipboard} from "./clipboard.js";

export function pasteExtension() {
  return pasteListener((event, view, shift) => {
    clipboard(event, text => pasteText(text, shift, runCommand));

    function runCommand(command) {
      command(view);
      event.stopPropagation();
      event.preventDefault();
    }
  });
}

function pasteText(text, alternative, runCommand) {
  const plainTextType = parsedUrlType(text.trim());
  if (plainTextType === 'image') {
    alternative || runCommand(pasteImage('image', text.trim()));
  }
  if (plainTextType === 'link') {
    runCommand(paste(text.trim()))
  }
  if (plainTextType === 'text') {
    runCommand(paste(text));
  }
}
